import work_surprise from './work_surprise';
import restuarant_problem from './restuarant_problem';
import vacation from './vacation';

const letters_fi = [];
letters_fi.push({ name: 'Work Surprise', content:work_surprise });
letters_fi.push({ name: 'Restuarant Problem', content:restuarant_problem });
letters_fi.push({ name: 'Vacation Friend', content:vacation });

export default letters_fi;